import { ProductViewPlaceValue, ProductViewTemplateModel } from './product-view-template.model';

import { MediasPublicConstants } from '@features/products/medias';
import { MediaLocation } from '@features/products/medias/domain/models/medias.models';
import { ProductPublicModels } from '@features/products/product';
import { EventFrom } from '@shared/analytics/COMMON/models/analytics-common.models';
import { MediaModel } from '@shared/media';
import { ProductViewPlace } from '@shared/product/models';
import { RelatedProductType } from '@shared/product/related-products/domain/models/related-products.models';

export enum ActionBadge {
    NAVIGATION = 'NAVIGATION',
    ADDCART = 'ADDCART',
    SHOWQUICKLY = 'SHOWQUICKLY',
}

export enum Position {
    left = 'left',
    right = 'right',
    top = 'top',
    bottom = 'bottom',
    none = 'none',
}

export enum ImageType {
    main = 'main',
    secondary = 'secondary',
    colorcut = 'colorcut',
    silhouette = 'silhouette',
    alternative = 'alternative',
    video = 'video',
    quadruple = 'quadruple',
    unknown = 'unknown',
    double = 'double',
}

export interface ProductViewConfig {
    location: MediaLocation;
    place: ProductViewPlace;
    media: MediaModel;
    defaultImageType?: string;
    // Optional
    baseColor?: string;
    discardVideos?: boolean;
    discardDoubleVideo?: boolean;
    discardDoubleImage?: boolean;
    discardFallback?: boolean;
    showDetails?: boolean;
    clickable?: boolean;
    showName?: boolean;
    showTags?: boolean;
    showDescription?: boolean;
    showLongDescription?: boolean;
    showPrice?: boolean;
    textPosition?: Position;
    imageType?: ImageType;
    imageTypeAlternative?: ImageType;
    showQuickly?: boolean;
    showQuicklyMobile?: boolean;
    showSelectSize?: boolean;
    showColors?: boolean;
    showDiscount?: boolean;
    showPromotions?: boolean;
    showMadeInExclusive?: boolean;
    styles?: {
        backgroundColor: string;
        fontColor: string;
        offerPrice: string;
        colorSelector: string;
        cardColor?: string;
    };
    showLimitedSeparatorData?: boolean;
    showLimitedAndDescription?: boolean;
    showVerticalImage?: boolean;
    showViewBundleProducts?: boolean;
    showBundleName?: boolean;
    showLinesInDetails?: boolean;
    showContentProjected?: boolean;
    // AÑADIDOS DESPUES DE REFACT
    overImageChange?: boolean;
    colorSelector?: ColorSelector;
    showSecondImageIfPossible?: boolean;
    // AÑADIDOS DESDE RELACIONADOS
    relatedsSectionId?: string;
    baseProduct?: ProductPublicModels.PublicProduct;
    parentType?: RelatedProductType;
    hidePriceText?: boolean;
    eventFrom?: EventFrom;
    set?: number;
    showMediaCarousel?: boolean;
    showMediaCarouselMobile?: boolean;
    multipleMedias?: number;
}

export const InitialConfigDefault: ProductViewConfig = {
    imageType: ImageType.main,
    clickable: true,
    location: MediasPublicConstants.PublicMediaLocationType.category_page,
    place: ProductViewPlaceValue.PRODUCT_GRID,
    media: {
        ratio: '3-4',
        alt: undefined,
        widthVW: undefined,
        showWaterMark: true,
    },
    discardDoubleVideo: false,
    discardFallback: false,
    // details
    showDetails: true,
    showDescription: false,
    showTags: true,
    showName: true,
    showPrice: true,
    showColors: true,
    textPosition: Position.bottom,
    showMadeInExclusive: true,
    showPromotions: true,
    showContentProjected: true,
    // image
    showQuickly: true,
    showQuicklyMobile: false,
    showDiscount: true,
    // relateds
    relatedsSectionId: undefined,
    baseProduct: undefined,
    parentType: undefined,
    hidePriceText: undefined,
    eventFrom: undefined,
    multipleMedias: 1,
};

export interface ColorSelector {
    type: string;
    colorsCount: number;
}

export interface ImageDataMedia {
    type: string;
    gridElementType: string;
    ref: string;
}

export enum Cd139Type {
    CART_YODA = 'CART_YODA',
    COMPLETE_LOOK = 'COMPLETE_LOOK',
    COMPLETE_LOOK_YODA = 'COMPLETE_LOOK_YODA',
    FRECUENTLY_BOUGHT_TOGETHER = 'FRECUENTLY_BOUGHT_TOGETHER',
    OTHER_YOU_MAY_LIKE = 'OTHER_YOU_MAY_LIKE',
    RECENTLY_VIEWED = 'RECENTLY_VIEWED',
    RECOMMENDED_FOR_YOU = 'RECOMMENDED_FOR_YOU',
    RELATED = 'RELATED',
    RELATED_BUYED = 'RELATED_BUYED',
    TOP_SALES = 'TOP_SALES',
}

export const InitialCategoryConfigDefault = {
    soldOut: false,
    productConf: new Map(),
    category: undefined,
    isCategoryNew: false,
};

export interface ViewModelProductView {
    product: ProductPublicModels.PublicProduct;
    templateConfig: ProductViewTemplateModel;
    medias: any;
    prices: any;
    linkHref: string;
}
